import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

export const LifeInsurancePolicyAmount = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="LifeInsurancePolicyAmount"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Death Benefit"
          decimalScale={2}
          allowNegative={false}
          leftIcon="far fa-dollar-sign"
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
          maxLength={14}
        />
      )}
    />
  );
};
